import React from 'react';
import {Requestdynamic} from '../../Network/Fetch';
import Cookies from 'universal-cookie'

import Modify from './ModifyMember'
import HeaderGoBack from './HeaderGoBack'
import PopUp from './PopUp'
import LoadingInfo from './LoadingInfo'
import UpdateModal from './ModalUpdateProfil'

class AllMember extends React.Component {
  constructor(props){
      super(props);
      this.state = {
        loadingMore: false,
        openModal: false,
        title: null,
        message: null,
        loading: true,
        IdMember: null,
        modify: false,
        Error: null,
        updateProfil: false,
        StatusUpdate: null,
        Picture: null
      }
    }

    GetSpecificMember = async () => {
      await this.sleep(500)

      var cookies = new Cookies();
      var Jwt = cookies.get('acces');
      var Params = {
        Jwt: Jwt,
        Id: this.state.IdMember,
        SizeImage: "Small"
      }
      var promise = await Requestdynamic('_getSpecificMember', Params);
      if (promise.error === false && promise.data.error === false)
      {
        var Data = promise.data.data
        if (!Data.MemberStatus || Data.MemberStatus !== 'NonMember'){
          this.setState({loading: false, openModal: true, title: 'Error', redirect: true, message: 'Information incorrect', accept_refuse: false, statusAccept_Refuse: null, actionAccept_Refuse: null, blocked: false, statusBlocked: null})
          return ;
        }
        try {
          var Keys = Object.keys(Data);
          var paramsSetState = {loading: false}
          for (var i = 0; i < Keys.length; i++){
            paramsSetState[Keys[i]] = Data[Keys[i]]
          }
          this.setState(paramsSetState)
        } catch (e) {
          this.setState({loading: false, openModal: true, title: 'Error', redirect: true, message: 'Un problème est survenue veuillez réesayer plus tard'})
        }
      }
      else {
        if (promise.error === true)
          this.setState({loading: false, openModal: true, title: 'Error', redirect: true, message: 'Un problème est survenue veuillez réesayer plus tard'})
        else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true)
        {
          cookies = new Cookies();
          cookies.remove('acces', { path: '/' })
          cookies.remove('infoAdmin', { path: '/' })
          await this.sleep(900)
          var url = '/login'
          const link = document.createElement('a');
          link.href = url;
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          return ;
        }
        else
          this.setState({loading: false, openModal: true, title: 'Error', redirect: true, message: 'Un problème est survenue veuillez réesayer plus tard'})
      }
    }

    _VerifySource = async () => {
      this.setState({loading: true}, async () => {

            if (!this.props.navigation.match.params.memberid){
              this.setState({loading: false, openModal: true, title: 'Error', redirect: true, message: 'Un problème est survenue veuillez réesayer plus tard'})
              return ;
            }
            this.setState({
              IdMember: this.props.navigation.match.params.memberid,
            }, async () => this.GetSpecificMember())
        })
    }

    componentDidMount(){
      this._VerifySource()
      this.goBack = this.goBack.bind(this);
    }

    goBack(){
      var paramsNavigate = {pathname: `/details_none_member/${this.state.IdMember}`}
      if (this.props.navigation.location && this.props.navigation.location.state && this.props.navigation.location.state.oldPage)
        paramsNavigate.state = {oldPage: this.props.navigation.location.state.oldPage}
        this.props.navigation.history.push(paramsNavigate);
    }

     sleep = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    _CheckPrivateInfo = (Error) => {
      try {
        var error = false;
        var ErrorPrivate = {}

        if (!this.state.FirstName || this.state.FirstName.length < 2)
        {
          error = true
          ErrorPrivate.FirstName = true
        }
        if (!this.state.LastName || this.state.LastName.length < 2)
        {
          error = true
          ErrorPrivate.LastName = true
        }
        if (error === true)
          Error.Private = ErrorPrivate
      } catch (e) {
        ErrorPrivate.FirstName = true
        ErrorPrivate.LastName = true
        Error.Private = ErrorPrivate
      }

    }

    _CheckSubscribeInfo = (Error) => {
      try {
        var error = false;
        var ErrorSubscribe = {}

        if (!this.state.Complement.Region || this.state.Complement.Region.length === 0)
        {
          error = true
          ErrorSubscribe.Region = true
        }
        if (!this.state.Complement.Source || this.state.Complement.Source.length === 0)
        {
          error = true
          ErrorSubscribe.Source = true
        }
        if (error === true)
          Error.Subscribe = ErrorSubscribe
      } catch (e) {
        ErrorSubscribe.Region = true
        Error.Subscribe = ErrorSubscribe
      }

    }


_fillParams = (ObjectName, target) => {
  if (!this.state[ObjectName] || !this.state[ObjectName][target])
    return null
  return (this.state[ObjectName][target])
}

_fillParamsDate = (ObjectName, target, index) => {
  try {
    if (!this.state[ObjectName] || !this.state[ObjectName][target])
      return null
    var DateSplit = this.state[ObjectName][target].split(' ')[0]
    if (DateSplit ===  "null/null/null")
      return null;
    return DateSplit.split('/')[index]
  } catch (e) {
    return (null)
  }
}

  _updateNoneMember = async () => {
    this.setState({Error: null}, async () => {
      var Error = {}

      this._CheckPrivateInfo(Error)
      this._CheckSubscribeInfo(Error)

      var KeysObjectError = Object.keys(Error).length;
      if (KeysObjectError !== 0)
      {
        this.setState({Error: Error})
        return ;
      }
      this.setState({updateProfil: true, StatusUpdate: "Waiting"}, async () => {
        var cookies = new Cookies();
        var Jwt = cookies.get('acces');
        var Params = {
          Jwt: Jwt,
          Id: this.state.IdMember,
          FirstName: this.state.FirstName,
          LastName: this.state.LastName,
          Region: this._fillParams("Complement", "Region"),
          Society: this._fillParams("Society", "Name"),
          Status: this._fillParams("Society", "Status"),
          Source: this._fillParams("Complement", "Source"),
          Tel: this._fillParams("Private", "TelPrivate"),
        }
        var promise = await Requestdynamic('_updateNoneMember', Params);
        if (promise.error === false && promise.data.error === false)
        {
          this.setState({StatusUpdate: "Success", message: "Les informations ont bien été mis à jour"})
          return ;
        }
        else {
          if (promise.error === true)
            this.setState({StatusUpdate: "Error", message: "Un problème est survenue veuillez ré-essayer plus tard"})
          else if (promise.data && promise.data.hasOwnProperty('jwt') && promise.data.jwt === true){
            cookies = new Cookies();
            cookies.remove('acces', { path: '/' })
            cookies.remove('infoAdmin', { path: '/' })
            await this.sleep(900)
            var url = '/login'
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            return ;
          }
          else
            this.setState({StatusUpdate: "Error", message: "Un problème est survenue veuillez ré-essayer plus tard"})
          return ;
        }
      })
    })
  }

 render() {
   return (
     <div style={{marginLeft: 10, overflowY: "auto"}}>
      <UpdateModal refParent={this} openModal={this.state.updateProfil} statusRequest={this.state.StatusUpdate} message={this.state.message}/>
      <PopUp redirect={this.state.redirect} refParent={this} openModal={this.state.openModal} message={this.state.message} title={this.state.title} />
      <LoadingInfo openModal={this.state.loading} />
      <HeaderGoBack refParent={this}/>
      <Modify Error={this.state.Error} refParent={this} intl={this.props.intl}/>
    </div>
   )
 }
}


export default AllMember;
